/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEndpointSlice = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13 9.874A4.002 4.002 0 0 0 12 2a4 4 0 0 0-1 7.874v4.148c-1.91.085-3.655.413-5.008.92-.79.296-1.498.673-2.027 1.142C3.437 16.552 3 17.197 3 18s.437 1.448.965 1.916c.207.184.442.353.698.51l-2.15 1.201.975 1.746 17-9.5-.976-1.746-3.899 2.179A19.984 19.984 0 0 0 13 14.022zM10 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm1 10.024v.86l-4.192 2.343a8.137 8.137 0 0 1-.114-.042c-.658-.247-1.121-.517-1.402-.765C5.01 18.17 5 18.026 5 18s.01-.17.292-.42c.28-.248.744-.518 1.402-.765 1.1-.412 2.598-.707 4.306-.79zm6.306 3.161c-1.026.385-2.4.667-3.968.771l-3.49 1.94A21.83 21.83 0 0 0 12 22c2.297 0 4.422-.347 6.008-.942.79-.296 1.498-.673 2.027-1.142.528-.468.965-1.113.965-1.916 0-.75-.382-1.363-.863-1.821l-1.912 1.062c.198.115.358.23.483.34.282.25.292.394.292.419s-.01.17-.292.42c-.28.248-.744.518-1.402.765z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEndpointSlice as EndpointSlice };
